// extracted by mini-css-extract-plugin
export default {"item":"_dd9ab608"};